/* ==========================================================================
   Studio Cleanout Sale — engine
   Four states: pre -> early -> public -> closed. Computed client-side only —
   the discounted price is never present in server-rendered HTML before the
   reveal instant; it's calculated here, in the browser, from the full price
   (already public) at the moment the clock allows it.

   Config is injected by snippets/sc-config.liquid as window.SC_CONFIG.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.SC_CONFIG || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  var TIME_RE = /^\d{1,2}:\d{2}$/;
  var OFFSET_RE = /^[+-]\d{2}:\d{2}$/;

  function toInstant(dateStr, timeStr, offset) {
    if (!dateStr) return null;
    var t = (timeStr && TIME_RE.test(timeStr)) ? timeStr : '00:00';
    if (t.length === 4) t = '0' + t;
    var off = OFFSET_RE.test(offset) ? offset : '+00:00';
    var d = new Date(dateStr + 'T' + t + ':00' + off);
    return isNaN(d.getTime()) ? null : d;
  }

  var startAt = toInstant(CFG.startDate, CFG.startTime, CFG.utcOffset);
  var publicAt = toInstant(CFG.publicDate, CFG.publicTime, CFG.utcOffset);
  var endAt = toInstant(CFG.endDate, CFG.endTime, CFG.utcOffset);

  // 'pre' | 'early' | 'public' | 'closed'
  function computeState() {
    var now = Date.now();
    if (endAt && now >= endAt.getTime()) return 'closed';
    if (publicAt && now >= publicAt.getTime()) return 'public';
    if (startAt && now >= startAt.getTime()) return 'early';
    return 'pre';
  }

  // The discount is live (price may be shown) during early + public only.
  function discountLive(state) {
    return state === 'early' || state === 'public';
  }

  function resolveView() {
    var override = CFG.previewState;
    if (override && override !== 'auto') return { state: override };
    var state = computeState();
    // noKeyRequired: the unlisted URL is the access control. Anyone who has
    // it and arrives before the start date still sees the live countdown
    // (the 'early' presentation), not a separate locked/coming-soon gate —
    // there's nothing to hide except the price itself, which discountLive()
    // already handles regardless of this.
    if (CFG.noKeyRequired && state === 'pre') return { state: 'pre' };
    return { state: state };
  }

  /* ---------- countdowns ------------------------------------------------ */
  function targetFor(name) {
    if (name === 'start') return startAt;
    if (name === 'public') return publicAt;
    return endAt;
  }

  function attr(el, name, value) {
    return el.querySelector('[' + name + '=' + JSON.stringify(value) + ']');
  }

  var countdowns = [];
  function registerCountdowns() {
    countdowns = $all('[data-sc-countdown]').map(function (el) {
      return {
        el: el,
        target: targetFor(el.getAttribute('data-sc-target')),
        d: attr(el, 'data-cd', 'd'), h: attr(el, 'data-cd', 'h'),
        m: attr(el, 'data-cd', 'm'), s: attr(el, 'data-cd', 's')
      };
    });
  }

  function tickCountdowns() {
    var now = Date.now();
    countdowns.forEach(function (c) {
      if (!c.target) return;
      var diff = Math.max(0, c.target.getTime() - now);
      var sec = Math.floor(diff / 1000);
      var d = Math.floor(sec / 86400); sec -= d * 86400;
      var h = Math.floor(sec / 3600); sec -= h * 3600;
      var m = Math.floor(sec / 60); sec -= m * 60;
      if (c.d) c.d.textContent = pad(d);
      if (c.h) c.h.textContent = pad(h);
      if (c.m) c.m.textContent = pad(m);
      if (c.s) c.s.textContent = pad(sec);
    });
  }

  /* ---------- price reveal ----------------------------------------------
     Each element: <span data-sc-price-reveal data-sc-price-cents="180000">
     The full price is public knowledge already (it's the normal displayed
     price) — only the computed SALE number is withheld from the markup
     until reveal, and even then it's written by this script, never by
     Liquid, so it never exists server-side.

     data-sc-price-cents is kept live for multi-variant products (currently
     just the "Unraveling, Melting, Vanishing" sculpture) by the
     'variant:change' listener below — Motion's theme.js dispatches that
     globally on document whenever the shopper picks a different option,
     with event.detail.variant.price already in cents.

     NOTE: `full` (data-sc-price-cents) is whatever Liquid's product.price
     returned server-side, which Shopify Markets already converts to the
     shopper's local currency when "local currencies" is on (true for this
     shop's International market) — money() below just formats whatever
     number it's given with a "$" glyph, it does not itself convert
     currency. saleAmountFor() MUST derive its result from `full` for this
     reason: a hardcoded absolute number (e.g. a fixed USD cent amount)
     would silently drift from the converted "was" price for any non-USD
     shopper. Found 2026-09-15 when a UK collector reported an override
     item's "sale" price displaying HIGHER than its "was" price —
     priceOverrides used to store fixed USD cents; now stores a 0–1
     fraction-of-full instead, exactly like the discountPct fallback. */
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function saleAmountFor(el, full) {
    var handle = el.getAttribute('data-sc-handle');
    var overrides = CFG.priceOverrides || {};
    if (handle && Object.prototype.hasOwnProperty.call(overrides, handle)) {
      return Math.round(full * overrides[handle] / 100) * 100;
    }
    return Math.round(full * (100 - (CFG.discountPct || 0)) / 100 / 100) * 100;
  }

  function renderPriceReveals(state) {
    var live = discountLive(state);
    $all('[data-sc-price-reveal]').forEach(function (el) {
      var full = parseInt(el.getAttribute('data-sc-price-cents'), 10);
      if (isNaN(full)) return;
      var plainEl = $('[data-sc-plain-price]', el);
      var saleEl = $('[data-sc-sale-price]', el);
      var wasEl = $('[data-sc-was-price]', el);
      if (plainEl) plainEl.textContent = money(full);
      if (live) {
        var sale = saleAmountFor(el, full);
        if (saleEl) saleEl.textContent = money(sale);
        if (wasEl) wasEl.textContent = money(full);
        el.classList.add('is-live');
      } else {
        el.classList.remove('is-live');
      }
    });
  }

  function registerVariantChangeListener() {
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || typeof variant.price !== 'number') return;
      var el = $('[data-sc-price-reveal]');
      if (!el) return;
      el.setAttribute('data-sc-price-cents', variant.price);
    });
  }

  /* ---------- landing-page state blocks ---------------------------------
     Same .sc-root / .sc-state[data-sc-state] pattern as the existing
     ea-drop engine, kept separate on purpose (see sc-config.liquid). */
  function applyRootState(state) {
    var root = $('.sc-root');
    if (!root) return;
    $all('.sc-state', root).forEach(function (el) {
      el.hidden = el.getAttribute('data-sc-state') !== state;
    });
    root.setAttribute('data-sc-ready', 'true');
    root.setAttribute('data-sc-view', state);
    document.dispatchEvent(new CustomEvent('sc:view', { detail: { state: state } }));
  }

  /* ---------- generic show/hide-by-state ---------------------------------
     Any element anywhere on the site (not just the landing page) can opt
     into this by adding data-sc-show-in="early public" (space-separated
     states it should be visible during). Used by the "back to sale" button
     on product pages, which needs to disappear once the sale is over rather
     than staying tag-gated forever. */
  function applyVisibilityToggles(state) {
    $all('[data-sc-show-in]').forEach(function (el) {
      var allowed = (el.getAttribute('data-sc-show-in') || '').split(/\s+/);
      el.hidden = allowed.indexOf(state) === -1;
    });
  }

  /* ---------- sticky countdown bar on scroll -----------------------------
     Same pattern as ea-drop.js's own initStickyBar() (see that file for the
     original) — reused rather than reinvented so this behaves identically
     to the other drop pages. Differences: keyed to data-sc-view/'sc:view'
     instead of data-ea-view/'ea:view', and shown during BOTH 'early' and
     'public' (not just early) since the discount + end countdown are both
     live for the whole sale here, not only during early access.
     No-ops harmlessly on pages without a .ea-stickybar (i.e. product pages —
     this file is loaded there too for the price reveal). */
  function initStickyBar() {
    var bar = $('.ea-stickybar');
    if (!bar) return;
    function currentAnchor() {
      return document.querySelector('.sc-state:not([hidden]) [data-sc-stickybar-after]');
    }
    function onScroll() {
      var anchor = currentAnchor();
      var trigger = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var root = $('.sc-root');
      var view = (root && root.getAttribute('data-sc-view')) || '';
      bar.classList.toggle('is-visible', trigger && (view === 'early' || view === 'public'));
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('sc:view', onScroll);
    onScroll();
  }

  function tick() {
    var view = resolveView();
    tickCountdowns();
    renderPriceReveals(view.state);
    applyRootState(view.state);
    applyVisibilityToggles(view.state);
  }

  function init() {
    registerCountdowns();
    registerVariantChangeListener();
    initStickyBar();
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();